import { isBoolean } from 'lodash';

// TODO: #remove - this service is not needed anymore
class ConfigsService {
    setCatalogAvailability(isAvailable) {
        if (isBoolean(isAvailable)) {
            this.catalogAvailable = isAvailable;
        } else {
            this.catalogAvailable = false;
        }
    }

    isCatalogAvailable() {
        return this.catalogAvailable;
    }
}

export default new ConfigsService();
